import React from 'react';
import PropTypes from 'prop-types';
import { CrownFilled } from '@ant-design/icons';

import { upgradeModal } from 'components/common/CheckPermissions/UpgradeSubscriptionModal';
import UserRoleSelect from './UserRoleSelect';

const DropdownFallback = ({ roleId }) => {
  const handleClick = () => {
    upgradeModal.open();
  };

  return (
    <div
      className="select-status-fallback-wrapper"
      onClick={handleClick}
      role="presentation"
    >
      <UserRoleSelect roleId={roleId} />
      <CrownFilled className="action-feature-icon" />
    </div>
  );
};

DropdownFallback.propTypes = {
  roleId: PropTypes.string,
};

export default DropdownFallback;
